export default "__VITE_ASSET__C$51gOPp__"